import JobListingCard from "@/components/molecules/JobCard"
import { Job } from "@/app/types"

type JobListProps = {
  jobBoardList: Job[]
}

export const JobBoardList = ({ jobBoardList }: JobListProps) => {
  return (
    <div className="flex flex-col items-center justify-start">
      {jobBoardList.map((jobBoard, index) => (
        <JobListingCard key={jobBoard.id} {...jobBoard} isFeatured={index === 0 ? true : false} />
      ))}
    </div>
  )
}
